import { render, staticRenderFns } from "./FolderAskInformationDialog.vue?vue&type=template&id=d8ac98c8&scoped=true"
import script from "./FolderAskInformationDialog.vue?vue&type=script&lang=js"
export * from "./FolderAskInformationDialog.vue?vue&type=script&lang=js"
import style0 from "./FolderAskInformationDialog.vue?vue&type=style&index=0&id=d8ac98c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8ac98c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
installComponents(component, {VCombobox})
